import { render, staticRenderFns } from "./antiMoneyLaunderingDetail.vue?vue&type=template&id=6f7e56eb&scoped=true"
import script from "./antiMoneyLaunderingDetail.vue?vue&type=script&lang=js"
export * from "./antiMoneyLaunderingDetail.vue?vue&type=script&lang=js"
import style0 from "./antiMoneyLaunderingDetail.vue?vue&type=style&index=0&id=6f7e56eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7e56eb",
  null
  
)

export default component.exports